const columns = [
    { name: "Status", uid: "status", sortable: false },
    { name: "Indutry", uid: "industry", sortable: false },
    { name: "Car", uid: "car", sortable: false },
    { name: "Company", uid: "company", sortable: false },
    { name: "Part", uid: "part", sortable: false },
    { name: "Created", uid: "duration", sortable: false },
    { name: "Delete ", uid: "delete", sortable: false },
    
];
                                                                                
const users =[
    {name: "Profile", uid: "profile", sortable: true},
    {name: "Role", uid: "role", sortable: false},
    {name: "fullName", uid: "fullName", sortable: false},
    {name: "car", uid: "car", sortable: false},
    {name: "email", uid: "email", sortable: false},
    {name: "part", uid: "part", sortable: false},
    {name:"phone",uid:"phone",sortable:false},
    {name:"created",uid:"created",sortable:false}
]

const statusOptions = [
    { name: "all", uid: "all" },
    { name: "Initiated", uid: "initiated" },
    { name: "Processing", uid: "processing" },
    { name: "Shipped", uid: "shipped" },
    { name: "In Transit", uid: "in Transit" },
    { name: "Completed", uid: "completed" },
    { name: "Delivered", uid: "delivered" },
    { name: "Dispute", uid: "dispute" },
    { name: "Cancelled", uid: "cancelled" },
];
  
export { columns, statusOptions,users };